import React, { FC } from 'react';
import { BooleanInput, useTranslate } from 'react-admin';
import { AutocompleteArrayTextInput } from '~/components/ra';
import { l } from '~/utils/solutions';
import { Skeleton } from '@material-ui/lab';
import { isEmpty } from 'lodash';
import { Solution } from '~/types';

interface CashDepositFormProps {
  record: Solution;
  keyName: string;
  loading: boolean;
}
export const CashDepositForm: FC<CashDepositFormProps> = ({ record, keyName, loading }) => {
  const translate = useTranslate();
  const t = (key: string, variant: any = 1): string =>
    translate(l(`featuresConfig.${key}`), variant);

  // Validation for autocomplete.
  const stringAutocompleteValidation = (values: string[]) => {
    const regex = /^[A-Z_]+$/;
    const invalidValues = values?.filter((value: string) => !regex.test(value));
    if (!isEmpty(invalidValues))
      return t('tagsValidation', { invalidValues: invalidValues.join(', ') });
  };
  return (
    <>
      <BooleanInput
        label={t('requireRecipientFullNameValidation')}
        source={`${keyName}.requireRecipientFullNameValidation`}
      />
      {loading ? (
        <Skeleton />
      ) : (
        <AutocompleteArrayTextInput
          label={t('operationSubtypes')}
          source={`${keyName}.operationSubtypes`}
          record={record}
          validate={stringAutocompleteValidation}
        />
      )}
    </>
  );
};
